import * as THREE from "three";

import loadGLBFromBase64 from "./loadGLBFromBase64";
import normalizeProduct from "./normalizeProduct";
import setCameraAndControls from "./setCameraAndControl";
import setupShadowPlane from "./setupShadowPlane";
import findLogoAndRotateProduct from "./findLogoAndRotateProduct";
import animateTo from "@/components/ProductProfile/utils/animateTo";
import { applyUvProjection, type UvProjection } from "./uvGeneration";



export default async function loadProductIntoScene(base64: string, uvProjection: UvProjection = 'none'): Promise<THREE.Group> {
    const threeViewer = (window as any).threeViewer as any;



    if (!threeViewer) {
        console.error("ThreeViewer not initialized on window object.");
        throw new Error("ThreeViewer not initialized.");
    }




    if (threeViewer.haveToCleanFromScene.length > 0) {
        threeViewer.cleanScene();
    }


    const product = await loadGLBFromBase64(base64);

    // Normalize the product position and scale
    const normalizedProduct = await normalizeProduct(product);

    normalizedProduct.name = "product";

    // Apply UV projection to all mesh geometries (after normalizeProduct bakes transforms)
    if (uvProjection !== 'none') {
        normalizedProduct.traverse((child: THREE.Object3D) => {
            if (child instanceof THREE.Mesh && child.geometry) {
                applyUvProjection(child.geometry, uvProjection)
            }
        })
    }

    // Clean up existing product from the scene if present
    if (threeViewer.normalizedProduct) {
        threeViewer.cleanScene();
        threeViewer.normalizedProduct = null;
    }



    // Setup shadow plane
    setupShadowPlane(threeViewer, normalizedProduct);

    //await calculateSectionPositions();

    // Position the logo correctly
    findLogoAndRotateProduct(normalizedProduct);

    threeViewer.haveToCleanFromScene.push(normalizedProduct);
    threeViewer.scene.add(normalizedProduct);
    threeViewer.product = normalizedProduct;


    // Configure camera and controls
    setCameraAndControls(threeViewer, product);
    animateTo(0, 0.002)


    THREE.Cache.clear();

    return product;
}






